import { render, staticRenderFns } from "./FormControlFranchiseId.vue?vue&type=template&id=3351cd2f"
import script from "./FormControlFranchiseId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlFranchiseId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports